import script from "./GiftExchangeRecord.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftExchangeRecord.vue?vue&type=script&setup=true&lang=js"

import "./GiftExchangeRecord.vue?vue&type=style&index=0&id=964b04e2&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-964b04e2"]])

export default __exports__